import axios from "../axios";
const handleLoginApi = (email, password) => {
    // console.log("hello from HandleLoginApi");
    return axios.post('/api/login', { email, password }); // nhu nay nghia "email: email input", "password: password input" de khop voi Country.email ben Nodejs
}
const getAllCountries = (inputid) => {
    // su dung cu phap cua template string
    return axios.get(`/api/get-all-countries?id=${inputid}`);


}
const createNewCountryService = (data) => {
    // console.log("hello from createNewCountry Service:", DataTransfer);
    return axios.post('/api/create-new-country', data)
}
const deleteCountryService = (data) => {
    // console.log("hello from createNewCountry Service:", DataTransfer);
    // return axios.delete('/api/delete-Country', data)
    return axios.delete('/api/delete-country', {
        data: {
            id: data.id
        }
    });
}
const editCountryService = (data) => {
    // console.log("hello from editCountryService Service:", data.id);
    return axios.put('/api/edit-country', data);

}
export {
    handleLoginApi,
    getAllCountries,
    createNewCountryService,
    deleteCountryService,
    editCountryService
}